import Swiper, { Navigation, Pagination, Grid, Lazy } from "swiper"

export default class FSlider {

  constructor (el) {
    this.el = el
    this.slider = null
    this.container = this.el.closest('.feedbacks')
    this.prev = this.container.querySelector('.swiper-controls__btn--prev')
    this.next = this.container.querySelector('.swiper-controls__btn--next')
    this.prevMobile = this.container.querySelector('.swiper-navigation__btn--prev')
    this.nextMobile = this.container.querySelector('.swiper-navigation__btn--next')
    this.pagination = this.container.querySelector('.swiper-navigation__pagination')
    this.isMobile = false
  }

  init () {
    this.initSlider()
    this.initEvents()
  }

  initEvents () {
    window.addEventListener('resize', () => this.updateSlider())
  }

  updateSlider () {
    if (window.innerWidth < 768) {
      if (this.isMobile) return;
      this.isMobile = true
      this.destroySlider()
      this.initSlider()
    } else {
      if (!this.isMobile) return;
      this.isMobile = false
      this.destroySlider()
      this.initSlider()
    }
  }

  initSlider () {
    this.slider = new Swiper(this.el, {
      modules: [ Navigation, Pagination, Grid, Lazy ],
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: true,
      watchSlidesProgress: true,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
      },
      grid: {
        rows: this.el.getAttribute('data-rows-sm') ?? 1,
        fill: 'row'
      },
      navigation: {
        prevEl: window.innerWidth < 768 ? this.prevMobile : this.prev,
        nextEl: window.innerWidth < 768 ? this.nextMobile : this.next
      },
      pagination: {
        el: this.pagination
      },
      observer: true,
      breakpoints: {
        1600: {
          spaceBetween: 24,
          grid: {
            rows: this.el.getAttribute('data-rows-xl') ?? 3
          }
        },
        1025: {
          spaceBetween: 20,
          grid: {
            rows: this.el.getAttribute('data-rows-lg') ?? 3
          }
        },
        768: {
          spaceBetween: 16,
          grid: {
            rows: this.el.getAttribute('data-rows-md') ?? 2
          }
        }
      }
    })
  }

  destroySlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

}
